import { gql } from "@apollo/client";

export default gql`
  mutation ToggleUsersCanAccessAccountPage($vendorId: ObjectId!, $isAccessAllowed: Boolean!) {
    toggleUsersCanAccessAccountPage(vendorId: $vendorId, isAccessAllowed: $isAccessAllowed)
  }
`;
